import { SVGProps, Ref, forwardRef } from 'react';

export const ChevronLeftOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m4.5 8 5 5 .99-.99L6.48 8l4.01-4.01L9.5 3z"
                fill="currentColor"
            />
        </g>
    </svg>
));
ChevronLeftOutlinedSize16Glyph.displayName = 'ChevronLeftOutlinedSize16Glyph';
